export function isDevelopment() {
  return import.meta.env.VITE_APP_ENVIRONMENT === "development";
}

export const isStage = () => import.meta.env.VITE_APP_ENVIRONMENT === "testing";

export function isProduction() {
  return import.meta.env.VITE_APP_ENVIRONMENT === "production";
}
